import React from "react";
import {
    Dialog as MuiDialog, DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent, DialogContentText as MuiDialogContentText,
    DialogActions as MuiDialogActions, Button as MuiButton
} from "@mui/material";
import { Trash2 } from "lucide-react";

interface Props {
    open: boolean;
    productName: string;
    providerName: string;
    removing: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function UnlinkConfirmDialog({ open, productName, providerName, removing, onConfirm, onCancel }: Props) {
    return (
        <MuiDialog
            open={open}
            onClose={removing ? undefined : onCancel}
            aria-labelledby="remove-integration-title"
            PaperProps={{ sx: { width: 420, borderRadius: "14px", p: 1 } }}
        >
            <MuiDialogTitle id="remove-integration-title" sx={{ display: "flex", alignItems: "center", gap: 1.25, pb: 1.5 }}>
                <span style={{
                    width: 36, height: 36, borderRadius: 9, background: "#fef2f2",
                    border: "1px solid #fecaca", display: "inline-flex", alignItems: "center",
                    justifyContent: "center", color: "#dc2626", flex: "0 0 auto"
                }}>
                    <Trash2 size={18} strokeWidth={1.9} />
                </span>
                <span style={{ fontSize: 16, fontWeight: 600 }}>Remove this connection?</span>
            </MuiDialogTitle>
            <MuiDialogContent>
                <MuiDialogContentText sx={{ fontSize: 13.5, lineHeight: 1.6 }}>
                    This disconnects <strong>{productName}</strong> from {providerName}. Other products connected to {providerName} are not affected.
                </MuiDialogContentText>
            </MuiDialogContent>
            <MuiDialogActions sx={{ px: 3, pb: 2, gap: 1.25 }}>
                <MuiButton variant="outlined" disabled={removing} onClick={onCancel}>Cancel</MuiButton>
                <MuiButton color="error" variant="contained" disabled={removing} onClick={onConfirm}>
                    {removing ? "Removing…" : "Remove Connection"}
                </MuiButton>
            </MuiDialogActions>
        </MuiDialog>
    );
}
